import { Fonts, Colors } from "../../utils/constants";
import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFFFFF',
    padding: 25,
  },

  brandingSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  brandingColumn1: {
    marginHorizontal: 5,
  },

  brandingColumn2: {
    marginHorizontal: 5,
  },

  brandingText: {
    fontSize: 14,
    fontFamily: 'Helvetica-Bold',
    alignSelf: 'flex-end',
    color: Colors.blue,
  },

  folio : {
    fontSize: 10,
    fontFamily: 'Helvetica',
    alignSelf: 'flex-end',
    color: Colors.orange,
    },

  date : {
    fontSize: 8,
    fontFamily: 'Helvetica',
    alignSelf: 'flex-end',
    color: Colors.blue,
  },

  line: {
    borderBottomWidth: 2,
    borderBottomColor: Colors.orange,
    marginBottom: 5,
    marginTop: 5,
  },

  logo: {
    maxHeight: 150,
    maxWidth: 150,
  }, 

  clientSection: {
    flexDirection: 'row',
    marginTop: 30,
  },

  clientInfo: {
    flex: 1, 
    marginHorizontal: 5,
  },

  clientInfoText: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'left',
    color: Colors.blue,
  },
  creditInfoText: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    alignSelf: 'flex-end',
    color: Colors.blue,
  },
  assetType: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'right',
    color: Colors.blue,
  },
  amount: {
    fontSize: 20,
    fontFamily: 'Helvetica-Bold',
    color: Colors.orange,
    textAlign: 'right',
  },
  tableHeader: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: Colors.orange,
    marginTop: 20,
  },
  tablelightGreyRow: {
    backgroundColor: Colors.lightGrey,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 2,
  },
  tabledarkGreyRow: {
    backgroundColor: Colors.darkGrey,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 2,
  },  
  tableText: {
    fontSize: 10,
    fontFamily: 'Helvetica',
    color: Colors.blue,
  },
  boldTableText: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: Colors.blue,
  },

  table: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  columnHeader: {
    width: '16.66667%',
    textAlign: 'center',
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: Colors.orange,
    marginTop: 20,
  },
  column: {
    width: '16.66667%',
    textAlign: 'center',
    fontSize: 10,
    fontFamily: 'Helvetica',
    color: Colors.blue,
    marginBottom: 2,
  },




  footer: {
    marginTop: 20,
    position: 'absolute',
    bottom: 0,
    width: '597',
    height: 100, 
    backgroundColor: Colors.blue,
    paddingTop: 10,
  },
  footerText: {
    fontSize: 6,
    fontFamily: 'Helvetica',
    color: '#FFFFFF',
    marginLeft: 55,
    marginRight: 120,
    marginBottom: 3,
  },
  footerBranding: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  footerBrandingText: {
    fontSize: 6,
    fontFamily: 'Helvetica',
    color: '#FFFFFF',
    paddingLeft: 25,
  },
  footerBrandingLogo: {
    maxHeight: 70,
    maxWidth: 70,
    marginRight: 35,
  },
});
export default styles;